<template>
  <section v-if="slots?.length">
    <div class="section-heading">
      <h2>Подключения</h2>
      <Badge variant="outline">{{ busySlotsCount() }}/{{ slots.length }}</Badge>
    </div>
    <div class="space-y-3">
      <slot-detail
        v-for="slot in slots"
        :key="slot.id"
        :conn-slot="slot"
        :queue="queue"
        @slot-changed="slotChanged()"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { Badge } from '@/components/ui/badge';

import SlotDetail from './SlotDetail.vue';

interface Props {
  slots: Slot[];
  queue: Queue[];
}

const props = defineProps<Props>();
const emit = defineEmits(['slotChanged']);

function slotChanged() {
  emit('slotChanged');
}

function busySlotsCount(): number {
  if (!props.slots || !Array.isArray(props.slots)) return 0;
  let counter = 0;
  props.slots.forEach((s) => {
    if (s.connection != null) counter++;
  });
  return counter;
}
</script>
